import { createSlice } from '@reduxjs/toolkit';
import { services } from '../../data/DummyData';
import { setAppointment } from '../roleSlice';
const initialState = {
  allowOTPPage: false,
  updateEmailToken: '',
  verifyToken: '',
  verifyForgotPassword: '',
  email: '',
  role: '',
  states: [],
  services: [],
  selectedServices: [],
  patientsQueue: [],
  patientsHistoryQueue: [],
  scheduleDate: null,
  clinicSlots: [],
  appointmentList: []
};
const commonSlice = createSlice({
  name: 'commonSlice',
  initialState,
  //   reducer needs a map
  reducers: {
    setUserRole(state, action) {
      state.role = action.payload;
    },

    setStates(state, action) {
      state.states = action.payload;
    },

    //set selected service by doctor (inside createAndViewServices)

    setPatientsQueue(state, action) {
      state.patientsQueue = action.payload;
    },
    setPatientsHistoryQueue(state, action) {
      state.patientsHistoryQueue = action.payload;
    },
    setPatientQueueAndHistoryQueueEmpty(state, action) {
      state.patientsHistoryQueue = [];
      state.patientsQueue = [];
    },

    setScheduleDate(state, action) {
      state.scheduleDate = action?.payload;
    },

    setClinicSlots(state, action) {
      state.clinicSlots = action?.payload;
    },
    setAppointmentList(state, action) {
      state.appointmentList = action?.payload;
    },
    setUpdateEmailToken(state, action) {
      state.updateEmailToken = action?.payload;
    },

    setHoldEmail(state, action) {
      state.email = action?.payload;
    },
    setEmailUpdateVerifyToken(state, action) {
      state.verifyToken = action.payload;
    },
    setVerifyForgotPassword(state, action) {
      state.verifyForgotPassword = action?.payload;
    },
    setOTPPage(state, action) {
      state.allowOTPPage = action?.payload;
    },
    setAfterVerifiedRoute(state, action) {
      state.afterVerifiedRoute = action?.payload;
    },
   
  
   
  }
});
export const {
  setUserRole,
  setStates,
  setPatientsQueue,
  setScheduleDate,
  setPatientsHistoryQueue,
  setPatientQueueAndHistoryQueueEmpty,
  setClinicSlots,
  setAppointmentList,
  setUpdateEmailToken,
  setHoldEmail,
  setEmailUpdateVerifyToken,
  setVerifyForgotPassword,
  setOTPPage,
  setAfterVerifiedRoute,
} = commonSlice.actions;
export default commonSlice.reducer;
